import { create } from "zustand";
import { getTodayDate, getDateMonthsAgo } from "../utils/dateUtils";

/** Intervalle par défaut : 1 mois (1 mois avant aujourd'hui → aujourd'hui) */
export const getDefaultDateRange = () => ({
  dateDebut: getDateMonthsAgo(1),
  dateFin: getTodayDate(),
});

/**
 * Store partagé pour les filtres des listes d'alertes (dates notamment).
 * Par défaut : intervalle d'un mois (30 derniers jours).
 */
interface AlertesListFiltersState {
  dateDebut: string;
  dateFin: string;
  setDateDebut: (value: string) => void;
  setDateFin: (value: string) => void;
  setDateRange: (debut: string, fin: string) => void;
  resetDateRange: () => void;
}

export const useAlertesListFiltersStore = create<AlertesListFiltersState>((set) => ({
  ...getDefaultDateRange(),
  setDateDebut: (dateDebut) => set({ dateDebut }),
  setDateFin: (dateFin) => set({ dateFin }),
  setDateRange: (dateDebut, dateFin) => set({ dateDebut, dateFin }),
  resetDateRange: () => set(getDefaultDateRange()),
}));
